import React from "react";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function OrderCard({ orderId, items, date }) {
   const navigate = useNavigate();

  return (
    <div className="mt-10 shadow-2xl rounded-3xl px-6 py-4 mx-2">
      <div className="flex gap-4 mb-4">
        <div className="bg-gray-200 shadow-xl size-16 rounded-full"></div>
        <div>
          <p className="font-bold">{orderId}</p>
          <p className="text-gray-600">{items}</p>
        </div>
      </div>
      <div className="flex justify-between items-center">
        <p className="text-[#868686]">{date}</p>
        <button
          onClick={() => navigate('/order/details')}
          className="bg-black items-center gap-2 px-4 py-2 flex text-white font-bold rounded-3xl cursor-pointer">

          Details <ArrowRight size={15} />
        </button>
      </div>
    </div>
  );
}